import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store';
import modalSlickAlt from 'src/images/modalSlickAlt.png';
import { changeEnterHTML } from 'src/utils/changeEnter';
import { trackingList } from 'src/utils/valueHTML';
import { getFontURL } from 'src/utils/getFontUrl';

const ModalSlideHTML: FC = () => {
  const bg = useSelector((state: RootState) => state.imageUpload.bg);
  const bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  const bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);
  const radius = useSelector((state: RootState) => state.imageUpload.radius);
  const deeplink = useSelector(
    (state: RootState) => state.imageUpload.deeplink
  );

  const text = useSelector((state: RootState) => state.editText.text);
  const fontSize = useSelector((state: RootState) => state.editText.fontSize);
  const fontWeight = useSelector(
    (state: RootState) => state.editText.fontWeight
  );
  const color = useSelector((state: RootState) => state.editText.color);
  const fontFamily = useSelector(
    (state: RootState) => state.editText.fontFamily
  );
  const textAlign = useSelector((state: RootState) => state.editText.textAlign);

  const btnText = useSelector((state: RootState) => state.buttons.btnText);
  const btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  const btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  const btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  const btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  const btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  const btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  const btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  const btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );
  const currentUser = useSelector(
    (state: RootState) => state.client.userCompany
  );
  const tracking = useSelector((state: RootState) => state.trackings.tracking);
  const button1 = useSelector((state: RootState) => state.trackings.button1);
  const button2 = useSelector((state: RootState) => state.trackings.button2);

  const multiTitleFontURL = getFontURL(fontFamily?.multi_title);
  const multiSubTitleFontURL = getFontURL(fontFamily?.multi_sub_title);
  const multiButtonURL = getFontURL(btnFontFamily?.multi_button);
  const closeImageUrl =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAMAAADVRocKAAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABaUExURQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB4eHh8fHy0tLS4uLqamprW1teLi4uPj4/Ly8oZg+lAAAAAUdFJOUwAQIDBAUF9gb3CPkJ+gr7C/z9/vMBy4TQAAAvhJREFUaN7FmtuaqyAMhYO1ZVMdR2H1LO//mvvCdkZbhITSb9Ztdf2VQAgHIpZUbfbdYB0AONt3e1MrKiWlW4uAhlZXBdxNj4j6Nxl11H1St83/8xYsWZ3l/8+BrQxEbSGSEFF1EKsVhHvnkCH2R6g9MrVnDb7KIluW0UwbhzdkN8nmx5vaJTo/3pb5sH+UsEMRrbbSBoW0Kd8/l3LB3qqK+QM2NOL2KKj9q79GUe0+F4CVMLQorO6jDQQA9QIQaKDjdfSXY9po7Tmb+IDj6L334znlf56eO8ZTRuADLt5zCJO/99dAnFU0At5zCA9/P0azXqiLjhzCj7/3iERhG3r36tOEmf8l1pGCNcphTBJm/rdDsHK9D+Lk62HC3P8U9lDRQZYgMPzvYe6RQ+D4T21UsTrJM4HlP7WRRgaB6Q+dyqMrBK4/WiIaICaw/WGJFCAl8P0BRTWkBIk/ajIQEkT+MNRARpD5oyHOYmlOkPnjmxgr4QVB5o+BeOXKK4HnD0vMBc0zgekPR9wqZEng+gNswILA988EpKsZOWDZRHxCbpC5BJfdTZkEm8jWkYHGI/TSVHEbZYRvYbK7nc4yQiNL17cTo156Ste10F9IqCVT5mP8SgiKEv00OL/wCQMRfYn9BYSWX3gt8xuXoClat0TmXyah4ha/r/mZRZgWCCbHn0eYNjpVlj+LcN9PCLbRMV2fzAnHcCK671OHfrww5scZ4Rr6fRtbxrLm31/CGFvGBsM8sub3X8JqiImIlFtdJ6fqhwfhEt8NMWvr5HR9MhFC62Sd2M45XPztekhPKWvP2eWBR/kNqafThK60f/u8KejK+r+eJOiPNhARccoLvpq/2FouGIa1o5xPb+8XC3TkPM2U8I8e4pgP+xdopeR54+at3uo2f3/USKSyx3TDvamgsz7CCc6sqy+5fye7nyD9CFuLT/UlCGey7iVwEdZkX0PZMmbSvqZ3VOn41RNT4A5Npb+C2wG21QVv6NSm6frH9Z+ha9jXf/4D6/hXXVtJWDsAAAAASUVORK5CYII=';
  const style = `
  @font-face {
    font-family: 'multiTitle';
    src: url(${multiTitleFontURL});
  }
  @font-face {
    font-family: 'multiSubTitle';
    src: url(${multiSubTitleFontURL});
  }
  @font-face {
    font-family: 'multiButton';
    src: url(${multiButtonURL});
  }
    /* reset */
    * {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      list-style: none;
      text-decoration: none;
      
    }
    html,
    body {
      height: 100%;
      overflow: hidden;
    }
    main {
      height: 100%;
      position: relative;
    }
    a {
      color: #000000;
      cursor: pointer;
    }
    button {
      background: none;
      border: none;
    }

    /* custom */
    .root {
      width: 100%;
      height: 100%;

      overflow: hidden;
      position: relative;
      background: none;
      display: flex;
      justify-content: center;
    }

    .background {
      width: 100%;
      height: 100%;

      position: absolute;
      top: 0;
      background: rgba(0, 0, 0, 0.8);
    }
    .modal_wrapper {
      width: calc(100% - 76px);      
      padding: 1rem 0;

      display: flex;
      flex-direction: column;
      gap: 1rem;

      overflow: hidden;
      position: absolute;
      top: 50%;
      transform: translate(0%, -50%);
      
      border-radius: ${radius?.background}px;
      ${
        bg === 'image'
          ? `background-image: url(${bgImage?.background});`
          : `background: ${bgColor?.background};`
      };

      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
    }

    .close_btn {
      position: absolute;
      right: 10%;
      top: 6%;
    }
    .close_btn button {
      width: 1.5rem;
      height: 1.5rem;
      
      background-image: url(${closeImageUrl});
      background-repeat: no-repeat;
      background-size: 1.5rem;
      background-position: center;

      font-size: 0;
      border: none;
      background-color: transparent;
    }

    .slick_wrapper,
    .slick_wrapper .slick-slider,
    .slick_wrapper .slick-list {
      width: 100%;
      height: 12rem;
    }
    .slick_wrapper .slick_image_wrapper {
      max-width: 12rem;
      width: 12rem;
      min-width: 12rem;
      max-height: 12rem;
      height: 12rem;
      min-height: 12rem;
      outline: 0;
    }
    .slick_image_wrapper img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      aspect-ratio: 1;
      outline: 0;
      border-radius: ${radius?.multi_image}px;
    }

    .slick_wrapper .slick-track {
      display: flex;
    }
    .slick_wrapper .slick-slide {
      margin: 0 0.5rem;
    }
    .slick_wrapper .slick-track img {
      object-fit: cover;
      border-radius: ${radius?.multi_image}px;
    }

    .contents_wrapper,
    .contents_wrapper .slick-slider,
    .contents_wrapper .slick-list,
    .contents_wrapper .slick-track div,
    .contents_wrapper .slick-track img {
      background-color: transparent;
    }
    .contents_wrapper {
      width: 100%;
      height: 8rem;
      padding: 0 1rem;
    }
    .contents_box {
      height: 8rem;
    }
    .contents_box .title {
      width: 100%;
      height: 3rem;      

      display: flex;
      align-items: center;
    }
    .title .title_inner {
      width: 100%;
      text-align: ${textAlign?.multi_title};
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      color: ${color?.multi_title};
      font-size: ${fontSize?.multi_title}rem;
      font-weight: ${fontWeight?.multi_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.multi_title
        )
          ? fontFamily.multi_title
          : 'multiTitle'
      };
    }
    .contents_box .sub_title {
      width: 100%;
      height: 4.5rem;

      display: flex;
      align-items: center;
    }
    .contents_box .sub_title_inner {
      width: 100%;
      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4;

      text-align: ${textAlign?.multi_sub_title};
      color: ${color?.multi_sub_title};
      font-size: ${fontSize?.multi_sub_title}rem;
      font-weight: ${fontWeight?.multi_sub_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.multi_sub_title
        )
          ? fontFamily.multi_sub_title
          : 'multiSubTitle'
      };
    }

    .slick-dots {      
      margin-bottom: 15px;      
    }
    .slick-dots li {
      width: 4px;
      height: 4px;
      margin: 0 0.5rem;
    }
    .slick-dots li button {
      width: 4px;
      height: 4px;
      padding: 0;
      border-radius: 4px;
      background: black;
      opacity: 0.3;
    }
    .slick-dots .slick-active button {
      opacity: 1;
    }
    .slick-dots li button::before {
      width: 4px;
      height: 4px;
      padding: 0;
      display: none;
    }

    .bar_blank {
      width: 100%;
      height: 0.25rem;      
    }
    .btn_wrapper {
      width: 100%;
      padding: 0 1rem;
      margin-top: 1rem;
    }
    .btn_wrapper button {
      width: 100%;
      height: 3rem;
      outline: 0;
      border: 0;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      font-size: ${btnFontSize?.multi_button}rem;
      font-weight: ${btnFontWeight?.multi_button};
      color: ${btnColor?.multi_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.multi_button
        )
          ? btnFontFamily.multi_button
          : 'multiButton'
      };
      border-radius: ${radius?.multi_button}px;
      background-color:rgba(${btnBgColorR?.multi_button},${
    btnBgColorG?.multi_button
  }, ${btnBgColorB?.multi_button}, ${btnBgColorA?.multi_button});
    }

    @media screen and (min-width: 568px) and (max-width: 1024px) {
        .modal_wrapper {
          width: 314px;    
        }
    }
  `;
  const deeplink_list = JSON.stringify(deeplink?.multi_image);
  const html = `
    <div class="root">
      <div class="background" onclick="appboyBridge.logClick('background'); appboyBridge.closeMessage();"></div>
      <div class="close_btn">
        <button>close</button>
      </div>
      <div class="modal_wrapper">
        <div class="slick_wrapper">
          <div class="slick_slider">${bgImage?.multi_image
            ?.map(
              (data: any, idx: number) => `
              <div class="slick_image_wrapper">
                <img
                  class="image"
                  src="${data && data !== '' ? data : modalSlickAlt}"
                  alt=""
                />
              </div>
            `
            )
            .join('')}</div>
        </div>
        <div class="contents_wrapper">
          <div class="contents_slider" style="margin: 0">${text?.multi_title
            ?.map(
              (data: any, idx: number) => `
            <div class="contents_box">
              <div class="title">
                <div class="title_inner">
                  ${changeEnterHTML(text?.multi_title?.[idx])}
                </div>
              </div>
              <div class="sub_title">
                <div class="sub_title_inner">
                  ${changeEnterHTML(text?.multi_sub_title?.[idx])}
                </div>
              </div>
            </div>`
            )
            .join('')}
          </div>
          <div class="bar_blank"></div>
        </div>
        <div class="btn_wrapper">
          <button class="button_text">
            ${btnText?.button}
          </button>
        </div>
      </div>
      <div id="deeplink-list" style="display:none;">
        ${deeplink_list}
      </div>
    </div>  
  `;

  // let deeplink_list = `[`;
  // for (let i = 0; i < deeplink?.multi_image?.length; i++) {
  //   deeplink_list += `'${deeplink?.multi_image?.[i]}'`;
  //   if (i !== deeplink?.multi_image?.length - 1) deeplink_list += ',';
  // }
  // deeplink_list += ']';

  let button_list = '[';
  for (let i = 0; i < btnText?.multi_button?.length; i++) {
    button_list += `'${btnText?.multi_button?.[i]}'`;
    if (i !== btnText?.multi_button?.length - 1) button_list += ',';
  }
  button_list += ']';

  let tracking_list = '[';
  for (let i = 0; i < tracking?.multi_image?.length; i++) {
    tracking_list += `['${tracking?.multi_image?.[i]}', '${tracking?.multi_button?.[i]}', '${tracking?.multi_sub_button?.[i]}'],`;
  }
  tracking_list += ']';

  const tracking_button_list = trackingList('MODAL SLIDE', button1, button2);

  const js = `
  document.addEventListener("DOMContentLoaded", function(){
    $('.slick_slider').slick({
      arrows: false,
      dots: false,
  
      centerMode: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      speed: 300,
      touchThreshold: 300
    });

    $('.contents_slider').slick({
      arrows: false,
      dots: true,
      fade: true,
  
      speed: 300,
      swipe: false
    });

    let currentIndex = 0;
    let button = ${button_list};
    $('.button_text').text(button[currentIndex]);
    $('.slick_number').text(currentIndex+1);
    $('.slick_slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
      currentIndex = $('.slick_slider').slick('slickCurrentSlide');
      $('.contents_slider').slick('goTo', currentIndex);
      $('.slick_number').text(currentIndex+1);
      $('.button_text').text(button[currentIndex]);
    });
    $('.contents_slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
      currentIndex = $('.contents_slider').slick('slickCurrentSlide');
      $('.slick_slider').slick('goTo', currentIndex);
      $('.slick_number').text(currentIndex+1);
      $('.button_text').text(button[currentIndex]);
    }); 

    let content = $("#deeplink-list").text();
    		
		let link = content.replace(/\\n|\\t/g, "").trim();
		
		let deeplink = JSON.parse(link);
        
    let tracking = ${tracking_list};
    let button1 = ${tracking_button_list[0]};
    let button2 = ${tracking_button_list[1]};
    $('.image').click(function() {
      appboyBridge.logClick(tracking[currentIndex][0]);
      try {
        if (button1[0].indexOf(currentIndex) !== -1) {
          appboyBridge.logClick('0');
        }
        if (button2[0].indexOf(currentIndex) !== -1) {
          appboyBridge.logClick('1');
        }
      } catch (err) {}
      window.location = deeplink[currentIndex];
    });
    $('.btn_wrapper').click(function() {
      appboyBridge.logClick(tracking[currentIndex][1]);
      try {
        if (button1[1].indexOf(currentIndex) !== -1) {
          appboyBridge.logClick('0');
        }
        if (button2[1].indexOf(currentIndex) !== -1) {
          appboyBridge.logClick('1');
        }
      } catch (err) {}
      window.location = deeplink[currentIndex];
    });
    $('.close_btn').click(function() {
      appboyBridge.logClick(tracking[currentIndex][2]);
      try {
        if (button1[2].indexOf(currentIndex) !== -1) {
          appboyBridge.logClick('0');
        }
        if (button2[2].indexOf(currentIndex) !== -1) {
          appboyBridge.logClick('1');
        }
      } catch (err) {}
      appboyBridge.closeMessage();
    });
  });
  `;

  return (
    <>
      <head>
        <meta charSet="UTF-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />

        {/* slick */}
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css"
        />
        <script
          type="text/javascript"
          src="https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js"
        />

        {/* google font */}
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Archivo:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          rel="stylesheet"
          as="style"
          href="https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/static/pretendard.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdn.jsdelivr.net/npm/normalize.css@8.0.1/normalize.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.9.0/slick.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.9.0/slick-theme.css"
        />
        <style dangerouslySetInnerHTML={{ __html: style }} />
      </head>
      <body dangerouslySetInnerHTML={{ __html: html }} />
      <script src="https://ajax.googleapis.com/ajax/libs/jquery/2.2.4/jquery.min.js" />
      <script src="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.9.0/slick.min.js" />
      <script dangerouslySetInnerHTML={{ __html: js }} />
    </>
  );
};
export default ModalSlideHTML;
